export const DEFAULT_NOTIFICATION_DURATION = 15000;

export const UNREAD_COUNT_CACHE_ID = 'pushMessages:{"unreadOnly":true}';
export const UNREAD_COUNT_WITH_HIDDEN_CACHE_ID = 'pushMessages:{"withHidden":true,"unreadOnly":true}';

export const PUSH_MESSAGE_CACHE_ID = "PushMessageType:";
export const PUSH_MESSAGES_CACHE_ID = "pushMessages:";
